import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/pen.tsx
var Pen = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M13.25 6.24994L16.0858 3.41416C16.8668 2.63311 18.1332 2.63311 18.9142 3.41415L20.5858 5.08573C21.3668 5.86678 21.3668 7.13311 20.5858 7.91416L17.75 10.7499M13.25 6.24994L3.33579 16.1642C2.96071 16.5392 2.75 17.0479 2.75 17.5784V21.2499H6.42157C6.95201 21.2499 7.46071 21.0392 7.83579 20.6642L17.75 10.7499M13.25 6.24994L17.75 10.7499",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M15.5555 2.88358C16.6294 1.80964 18.3706 1.80964 19.4445 2.88358L21.1161 4.55515C22.1901 5.6291 22.1901 7.3703 21.1161 8.44424L18.8105 10.7498L13.25 5.18934L12.1893 6.25L17.7498 11.8105L8.36612 21.1942C7.85039 21.71 7.15092 21.9997 6.42157 21.9997H2.75C2.33579 21.9997 2 21.6639 2 21.2497V17.5781C2 16.8488 2.28973 16.1493 2.80546 15.6336L15.5555 2.88358Z",
		fill: "currentColor"
	})
});
//#endregion
export { Pen };
